import { useRef } from "react";
import Card from "../ui/Card";
import classes from "./NewRelationForm.module.css";

export default function NewRelationForm(props) {
    const nameInputRef = useRef();
    const addressInputRef = useRef();

    function submitHandler(event) {
        event.preventDefault();
        const enteredName = nameInputRef.current.value;
        const enteredAddress = addressInputRef.current.value;
        const bodyData = {
            name: enteredName,
            address: enteredAddress
        };
        props.onStoreNewRelation(bodyData);
    }

    return <Card className={classes.card}>
        <form className={classes.form} onSubmit={submitHandler}>
            <div className={classes.control}>
                <label htmlFor='title'>Name</label>
                <input type='text' required id='name' ref={nameInputRef} />
            </div>
            <div className={classes.control}>
                <label htmlFor='title'>Address</label>
                <input type='text' required id='address' ref={addressInputRef} />
            </div>
            <div className={classes.action}>
                <button>Submit</button>
            </div>
        </form>
    </Card>
}